import { checkScrollPoints } from "./check-scroll-points";

export function stickyCardsScroll() {
	
	const $body = $("body");
	const $window = $(window);
	// const $header = $(".header");
	const $section = $(".sticky-cards");
	const $items = $section.find(".item");
	const floatingPoster = $section.find(".floating-poster");
	const $image = $section.find(".floating-poster > img");
	const $icon = $section.find(".floating-poster .icon img");
	
	$window.on("scroll load resize", function () {
		
		if ($body.hasClass("no-touch")) {
			checkScrollPoints($items, $(this).scrollTop(), window.innerHeight / 2, showCurrentPoster, hideCurrentPoster);
		}
	});
	
	function showCurrentPoster(i) {
		const $imageSrc = $($items).eq(i).find(".poster > img").attr("src");
		const $iconSrc = $($items).eq(i).find(".poster .icon img").attr("src");

		$($items).eq(i).addClass("current");
		
		if ( $image.attr("src") !== $imageSrc && $icon.attr("src") !== $iconSrc ) {
			floatingPoster.addClass("animate");

			setTimeout(() => {
				$($image).attr("src", $imageSrc);
				$($icon).attr("src", $iconSrc);
			}, 200);
			setTimeout(() => {
				floatingPoster.removeClass("animate");
			}, 210);
		}
	}
	
	function hideCurrentPoster(i) {
		$($items).eq(i).removeClass("current");
	}
}


// WEBPACK FOOTER //
// ./assets/js/modules/sticky-cards-scroll.js